import { render, staticRenderFns } from "./Productpectaculars.vue?vue&type=template&id=f45fb53e&scoped=true&"
import script from "./Productpectaculars.vue?vue&type=script&lang=js&"
export * from "./Productpectaculars.vue?vue&type=script&lang=js&"
import style0 from "./Productpectaculars.vue?vue&type=style&index=0&id=f45fb53e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45fb53e",
  null
  
)

export default component.exports